import { FormikBillingContactForm } from "./FormikBillingContactForm.js";
import "react";
import { Modal } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
// src/modules/Organizations/shared/Subcription/components/BillingContactFormModal.tsx
function BillingContactFormModal({ closeHandler, contact, isSubmitting, onSubmit }) {
	return /* @__PURE__ */ jsx(Modal, {
		closeHandler,
		header: "New Billing Contact",
		width: "sm",
		children: /* @__PURE__ */ jsx(FormikBillingContactForm, {
			contactValues: contact,
			onSubmit,
			isSubmitting
		})
	});
}
export { BillingContactFormModal };

//# sourceMappingURL=BillingContactFormModal.js.map